import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, isRef as _isRef, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/selladora_web_02.jpg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "level is-mobile pt-6 pb-0" }
const _hoisted_3 = { class: "level-item level-right has-text-right" }
const _hoisted_4 = { class: "block pb-6" }
const _hoisted_5 = { class: "image" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "container pb-6" }
const _hoisted_8 = { class: "block" }
const _hoisted_9 = {
  class: "has-text-justified has-text-primary is-size-6 pt-6 pb-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_10 = { class: "pb-6" }
const _hoisted_11 = { class: "image is-16by9" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"block pt-6\" style=\"background-color:#40587d;\"><div class=\"columns level\"><div class=\"column level-left is-three-quarters-desktop is-three-quarters-tablet is-three-quarters-widescreen is-three-quarters-fullhd is-full-mobile is-mobile\" style=\"padding-left:3rem;padding-right:3rem;\"><h2 class=\"has-text-white is-size-4\" style=\"font-family:Calibri;\"> TE INVITAMOS A OPTIMIZAR TUS PROCESOS DE SELLADO CON EL APOYO DE EXPERTOS EN LA INDUSTRIA </h2><p class=\"has-text-white is-size-6 is-mobile pt-2 pb-6\" style=\"font-family:Calibri;font-weight:bold;\"> Nuestros ingenieros están a tu disposición para entender tus desafíos y ofrecerte orientación. Solicita una llamada o reunión hoy mismo. </p></div><div class=\"column level-rigth is-one-quarter-desktop is-one-quarter-widescreen is-one-quarter-fullhd is-one-quarter-tablet is-full-mobile is-mobile pb-6 has-text-centered\"><button class=\"button has-text-white is-normal has-background-yellow\" style=\"font-family:Calibri;font-weight:bold;border:none;\"> CHATEA CON NOSOTROS </button></div></div></div>", 1)
const _hoisted_14 = { class: "block" }
const _hoisted_15 = { class: "columns" }
const _hoisted_16 = { class: "column" }
const _hoisted_17 = {
  class: "has-text-primary is-size-5",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_18 = {
  class: "has-text-primary is-size-6 pl-6",
  style: {"font-family":"Calibri"}
}
const _hoisted_19 = { class: "column" }
const _hoisted_20 = {
  class: "has-text-primary is-size-5",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_21 = {
  class: "has-text-primary is-size-6 pl-6",
  style: {"font-family":"Calibri"}
}
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"block pt-6\"><div class=\"columns level\"><div class=\"column is-mobile level-left is-three-quarters-desktop is-three-quarters-tablet is-three-quarters-fullhd is-three-quarters-widescreen is-full.mobile\"><p class=\"has-text-primary is-size-5\" style=\"font-family:Calibri;\"> EXTRAS DISPONIBLES: CORTADORAS Y CODIFICADORES. </p></div><div class=\"column is-mobile level-rigth is-one-quarter-desktop is-one-quarter-tablet is-one-quarter-fullhd is-one-quarter-widescreen has-text-right-desktop has-text-right-widescreen has-text-right-fulhd has-text-right-tablet has-text-centered-mobile is-full-mobile\"><button class=\"button has-text-white is-normal has-background-yellow\" style=\"font-family:Calibri;font-weight:bold;border:none;\"> DESCARGA LA FICHA TÉCNICA </button></div></div></div>", 1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("figure", { class: "image is-16by9" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "has-ratio",
    src: _imports_0,
    alt: "selladora_web_02.jpg"
  })
], -1)
const _hoisted_24 = { class: "container" }
const _hoisted_25 = { class: "block pb-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary is-size-6 has-text-justified pt-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Tenemos el conocimiento y la experiencia integrando selladoras de bolsas en una amplia gama de industrias. Estamos aquí para escucharte y ayudarte a encontrar la mejor solución para tus necesidades. A la hora de elegir una selladora de bolsas muchos factores entran en juego, desde el tipo de bolsa, la cantidad a envasar por minuto, el tipo de producto, entre otros. Alcanza tus objetivos seleccionando el equipo correcto. ¡No esperes más, contáctanos ahora! ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary is-size-5 has-text-justified pt-5",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " MANOS A LA OBRA ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary is-size-6 has-text-justified",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Llena el formulario y un asesor se pondrá en contacto contigo. ", -1)
const _hoisted_29 = { class: "pt-5" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Nombre\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Apellido\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Empresa\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"E-mail\" type=\"email\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Teléfono\" type=\"phone\"></div></div>", 5)
const _hoisted_35 = { class: "field" }
const _hoisted_36 = { class: "control" }
const _hoisted_37 = {
  class: "select",
  style: {"width":"100%"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", {
  class: "has-text-gray",
  disabled: "",
  selected: "",
  value: ""
}, " Forma de contacto ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: "whatsapp" }, "WhatsApp", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "email" }, "E-mail", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: "llamada" }, "Llamada", -1)
const _hoisted_42 = [
  _hoisted_38,
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"País\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Estado\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Comentarios\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><label class=\"checkbox\"><input type=\"checkbox\"> Acepto <a href=\"#\">Términos y condiciones</a> y <a href=\"#\">Aviso de privacidad</a></label></div></div><div class=\"field is-grouped is-grouped-centered\"><div class=\"control\"><button class=\"button has-background-yellow has-text-white\" style=\"width:15rem;\"> ENVIAR </button></div></div>", 5)
const _hoisted_48 = { class: "container" }

import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import { useEquipos } from "@/use-equipos";
import SvgIcon from "@jamescoyle/vue-icon";
import EquiposCarrusel from "@/components/EquiposCarrusel.vue";
import ContactMedia from "@/components/ContactMedia.vue";
import { mdiCheckboxMarkedCircle, mdiMenuLeft, mdiMenuRight } from "@mdi/js";
import { ref } from "vue";
import { useWindowSize } from "vue-window-size";


export default /*#__PURE__*/_defineComponent({
  __name: 'EquipoView',
  setup(__props) {

const { width } = useWindowSize();

const { currentEquipo, initialize } = useEquipos();
initialize();
const featuresLength = currentEquipo.value?.features.length || 0;
const featuresLeft = currentEquipo.value?.features.slice(0, featuresLength / 2);
const featuresRigth = currentEquipo.value?.features.slice(
  featuresLength / 2,
  featuresLength
);
let formaContacto = ref("");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ContactBar),
      _createVNode(NavigationBar),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(SvgIcon), {
            class: "has-text-yellow",
            type: "mdi",
            path: _unref(mdiMenuLeft),
            style: {"width":"50px","height":"50px"}
          }, null, 8, ["path"]),
          _createVNode(_unref(SvgIcon), {
            class: "has-text-yellow",
            type: "mdi",
            path: _unref(mdiMenuRight),
            style: {"width":"50px","height":"50px"}
          }, null, 8, ["path"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", {
          class: _normalizeClass(["has-text-left has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
          style: {"font-family":"Calibri","font-weight":"bold"}
        }, _toDisplayString(_unref(currentEquipo)?.nombre), 3),
        _createElementVNode("h1", {
          class: _normalizeClass(["has-text-left has-text-green", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
          style: {"font-family":"Calibri"}
        }, _toDisplayString(_unref(currentEquipo)?.codigo), 3)
      ])
    ]),
    _createElementVNode("figure", _hoisted_5, [
      _createElementVNode("img", {
        class: "has-ratio",
        src: _unref(currentEquipo)?.imgShowRoom,
        alt: _unref(currentEquipo)?.alt
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(currentEquipo)?.descripcion), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("figure", _hoisted_11, [
          _createElementVNode("iframe", {
            width: "640",
            height: "360",
            class: "has-ratio",
            src: 'https://www.youtube.com/embed/' + _unref(currentEquipo)?.video,
            frameborder: "0",
            allowfullscreen: ""
          }, null, 8, _hoisted_12)
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h1", {
          class: _normalizeClass(["has-text-centered has-text-primary pt-6", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
          style: {"font-family":"Calibri","font-weight":"bold"}
        }, " LO MAS IMPORTANTE ", 2),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featuresLeft), (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "p-4",
                  key: index
                }, [
                  _createElementVNode("p", _hoisted_17, [
                    _createVNode(_unref(SvgIcon), {
                      type: "mdi",
                      path: _unref(mdiCheckboxMarkedCircle),
                      style: {"color":"#38ac61","vertical-align":"text-bottom"}
                    }, null, 8, ["path"]),
                    _createTextVNode(_toDisplayString(" " + item.titulo), 1)
                  ]),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(item.descripcion), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featuresRigth), (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "p-4",
                  key: index
                }, [
                  _createElementVNode("p", _hoisted_20, [
                    _createVNode(_unref(SvgIcon), {
                      type: "mdi",
                      path: _unref(mdiCheckboxMarkedCircle),
                      style: {"color":"#38ac61","vertical-align":"text-bottom"}
                    }, null, 8, ["path"]),
                    _createTextVNode(_toDisplayString(" " + item.titulo), 1)
                  ]),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(item.descripcion), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _hoisted_22
    ]),
    _hoisted_23,
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("h1", {
          class: _normalizeClass(["has-text-centered has-text-primary pt-6", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
          style: {"font-family":"Calibri","font-weight":"bold"}
        }, " NUESTRA EXPERIENCIA Y BUEN SERVICIO HACEN LA DIFERENCIA ", 2),
        _hoisted_26,
        _hoisted_27,
        _hoisted_28,
        _createElementVNode("form", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formaContacto) ? (formaContacto).value = $event : formaContacto = $event)),
                  style: _normalizeStyle([{"width":"100%"}, _unref(formaContacto) == '' ? 'color: lightGray' : ''])
                }, _hoisted_42, 4), [
                  [_vModelSelect, _unref(formaContacto)]
                ])
              ])
            ])
          ]),
          _hoisted_43
        ])
      ])
    ]),
    _createVNode(ContactMedia),
    _createElementVNode("div", _hoisted_48, [
      _createVNode(EquiposCarrusel, {
        clasification: "todos",
        label: "OTROS EQUIPOS"
      })
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})